import { useMutation, useQueryClient } from "@tanstack/react-query";
import api from "@/lib/api";

const usersApi = {
  forgotPassword: async (email) => {
    const response = await api.post("/users/forgot-password", { email });
    return response.data;
  },

  resetPassword: async ({ password, accessToken, refreshToken }) => {
    const response = await api.post("/users/reset-password", {
      password,
      accessToken,
      refreshToken,
    });
    return response.data;
  },
};

export const useForgotPassword = (options = {}) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: usersApi.forgotPassword,
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ["users"] });
      options.onSuccess?.(data);
    },
    ...options,
  });
};

export const useResetPassword = (options = {}) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: usersApi.resetPassword,
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ["users"] });
      options.onSuccess?.(data);
    },
    ...options,
  });
};
